import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const Modal = ({ isOpen, children }) => isOpen ?
  (
    <div className="modal -not-full">
      { children }
    </div>
  ) : null;

Modal.defaultProps = {
  isOpen: false
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/index.js